import React, { useContext, useState, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "./SidebarLayout.css"; 
import Footer from "./Footer"; 
import { PuaContext } from "./PuaContext"; 

function SidebarLayout() {
  const currentSet = useContext(PuaContext); 
  const [menuActive, setMenuActive] = useState(false); 
  const location = useLocation(); 

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

 
  useEffect(() => {
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0; 
  }, [location]); 

  return (
    <div className="sidebar-layout">
      {/* Contenedor principal para el layout */}
      <div className="sidebar-container">
        {/* Botón de Menú de Hamburguesa */}
        <div className="menu-btn" onClick={toggleMenu}>
          <ion-icon name="menu-outline" size="large"></ion-icon>
        </div>

        {/* Menú Desplegable para Móviles */}
        <div className={`menu ${menuActive ? "active" : ""}`}>
          <div className="close-menu" onClick={toggleMenu}>
            <ion-icon name="close-outline" size="large"></ion-icon>
          </div>
          <nav className="sidebar-navigation">
            <ul>
              {currentSet.map((item, index) => (
                <li key={index}>
                  {item.text === "Home" ? (
                    <a href={item.path} className="sidebar-link" onClick={toggleMenu}>
                      <img src={item.src} alt={item.text} className="sidebar-icon" />
                      <span>{item.text}</span>
                    </a>
                  ) : (
                    <Link to={item.path} className="sidebar-link" onClick={toggleMenu}>
                      <img src={item.src} alt={item.text} className="sidebar-icon" />
                      <span>{item.text}</span>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>

        
        <nav className="sidebar-navigation">
          <ul>
            {currentSet.map((item, index) => (
              <li key={index}>
                {item.text === "Home" ? (
                  <a href={item.path} className="sidebar-link">
                    <img src={item.src} alt={item.text} className="sidebar-icon" />
                    <span>{item.text}</span>
                  </a>
                ) : (
                  <Link to={item.path} className="sidebar-link">
                    <img src={item.src} alt={item.text} className="sidebar-icon" />
                    <span>{item.text}</span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

       
        <div className="sidebar-content">
          <Outlet />
        </div>
      </div>

      <footer className="footer sidebar-footer">
        <span>&copy; 2024 Javier Cobalto</span>
        <img src="/images/carlanca.png" alt="Logo de Javier Cobalto" className="footer-logo" />
      </footer>
    </div>
  );
}

export default SidebarLayout;